<template>
  <AppDialog
    :title="submitted ? 'Thanks for your feedback!' : 'Share feedback on IP Location'"
    :show="show"
    :size="submitted ? 'small' : 'medium'"
    position="centered"
    append-to-body
    @close="close"
  >
    <template v-if="submitted">
      <p
        data-testid="ip-location-feedback-description"
        class="text-16"
      >
        Our product team will review it.
      </p>
    </template>
    <template v-else>
      <p
        data-testid="ip-location-feedback-description"
        class="text-16"
      >
        Help us improve this feature. Your feedback goes directly to our product team.
      </p>
      <div class="form-group">
        <AppTextareaCounter
          :value="feedbackText"
          data-testid="ip-location-feedback-textarea"
          :rows="5"
          placeholder="Write your feedback here ..."
          @input="onFeedbackInput"
        />
      </div>
    </template>
    <template #footer>
      <template v-if="submitted">
        <AppButton
          type="primary"
          block
          @click="close"
        >
          Done
        </AppButton>
      </template>
      <template v-else>
        <AppButton
          data-testid="ip-location-feedback-cancel-btn"
          @click="close"
        >
          Cancel
        </AppButton>
        <AppButton
          data-testid="ip-location-feedback-submit-btn"
          type="primary"
          :disabled="isSubmitButtonDisabled"
          @click="submit"
        >
          {{ submitting ? 'Sharing...' : 'Share' }}
        </AppButton>
      </template>
    </template>
  </AppDialog>
</template>

<script>
import { UserOrganizationsResource } from '~/resources';
import AppDialog from '~/components/AppDialog.vue';
import AppTextareaCounter from '~/components/AppTextareaCounter.vue';
import AppButton from '~/components/AppButton.vue';

export default {
  name: 'IpLocationFeedbackDialog',
  components: {
    AppDialog,
    AppTextareaCounter,
    AppButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    membershipId: {
      type: Number,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    userName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      feedbackText: '',
      submitting: false,
      submitted: false,
    };
  },
  computed: {
    isSubmitButtonDisabled() {
      return this.submitting || !this.feedbackText?.trim();
    },
  },
  methods: {
    close() {
      this.$emit('close');
      this.feedbackText = '';
      this.submitted = false;
    },
    onFeedbackInput(value) {
      this.feedbackText = value.slice(0, 1000);
    },
    submit() {
      if (!this.feedbackText.trim()) {
        return;
      }

      this.submitting = true;

      window.analytics?.track('IP Location Feedback Submitted', {
        feature: 'ip_geoloc',
        text: this.feedbackText.trim(),
      });

      UserOrganizationsResource.submitIpLocationFeedback(
        { id: this.membershipId },
        { feedback: this.feedbackText },
      ).finally(() => {
        this.submitted = true;
        this.submitting = false;
      });
    },
  },
};
</script>
